import { Line as FabricLine } from 'fabric';

class CustomFabricLine extends FabricLine<FabricLine & { zIndex?: number }> {
  declare zIndex: number;
}

export default CustomFabricLine;
